exports.components = {
  "component---src-pages-get-started-jsx": () => import("./../../../src/pages/get-started.jsx" /* webpackChunkName: "component---src-pages-get-started-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-modular-index-jsx": () => import("./../../../src/pages/modular-index.jsx" /* webpackChunkName: "component---src-pages-modular-index-jsx" */)
}

